import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./PlanTransition.css";

const thoughts = [
  "Most people overestimate what they can do in a month and underestimate what they can do in an year.",
  "The life you want is built in the hours nobody sees.",
  "Decisions compound. So does avoidance.",
  "A goal without a deadline is a wish. You just gave yours one.",
  "Discipline is choosing what you want most over what you want now.",
];

// ===== TIMING CONSTANTS =====
const COUNT_DURATION = 2000; // ms
const HOLD_BEFORE_ACTIONS = 1000; // ms
const AUTO_REDIRECT_DELAY = 10000; // ms
const FRAME_INTERVAL = 16; // ~60fps

const PlanTransition = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const { planId, durationInYears } = state || {};

  const [displayDays, setDisplayDays] = useState(0);
  const [showActions, setShowActions] = useState(false);

  const thought = useMemo(
    () => thoughts[Math.floor(Math.random() * thoughts.length)],
    []
  );

  /* ---------- SAFETY ---------- */
  useEffect(() => {
    if (!planId || !durationInYears) {
      navigate("/dashboard");
    }
  }, [planId, durationInYears, navigate]);

  /* ---------- DAYS ---------- */
  const daysRemaining = useMemo(
    () => durationInYears * 365,
    [durationInYears]
  );

  /* ---------- COUNT-UP ---------- */
  useEffect(() => {
    let current = 0;
    const totalFrames = COUNT_DURATION / FRAME_INTERVAL;
    const increment = daysRemaining / totalFrames;

    const interval = setInterval(() => {
      current += increment;

      if (current >= daysRemaining) {
        setDisplayDays(daysRemaining);
        clearInterval(interval);
      } else {
        setDisplayDays(Math.floor(current));
      }
    }, FRAME_INTERVAL);

    return () => clearInterval(interval);
  }, [daysRemaining]);

  /* ---------- SHOW BUTTON + AUTO REDIRECT ---------- */
  useEffect(() => {
    if (displayDays !== daysRemaining) return;

    // show button after short pause
    const showTimer = setTimeout(() => {
      setShowActions(true);
    }, HOLD_BEFORE_ACTIONS);

    // auto redirect after 10s
    const redirectTimer = setTimeout(() => {
      navigate(`/dashboard/year-plan/${planId}`);
    }, HOLD_BEFORE_ACTIONS + AUTO_REDIRECT_DELAY);

    return () => {
      clearTimeout(showTimer);
      clearTimeout(redirectTimer);
    };
  }, [displayDays, daysRemaining, navigate, planId]);

  return (
    <div className="plan-transition">
      <div className="pt-content">
        <div className="pt-days">{displayDays}</div>
        <div className="pt-label">days remaining</div>

        <div className="pt-divider" />

        <div className="pt-thought">{thought}</div>

        {showActions && (
          <button
            className="pt-cta"
            onClick={() => navigate(`/dashboard/year-plan/${planId}`)}
          >
            Go to Dashboard
          </button>
        )}
      </div>
    </div>
  );
};

export default PlanTransition;
